import { $clientPaymentAccount } from '../../../store/states';

import {
    fetchClientPaymentMethods,
    fetchFlexMonthStatus,
    fetchInvoices,
    fetchSubscriptions,
    fetchTaxIds,
} from './effects';
import { $flexMonthStatuses, $invoices, $subscriptions, $taxIds } from './states';

// Client payment account payment methods
$clientPaymentAccount.on(fetchClientPaymentMethods.doneData, (clientPaymentAccount, data) => {
    if (clientPaymentAccount === null) {
        return clientPaymentAccount;
    }

    const clientPaymentAccountCopy = { ...clientPaymentAccount };

    clientPaymentAccountCopy.payment_methods = data.items.map((clientPaymentMethod) => ({
        id: clientPaymentMethod.id,
        external_id: clientPaymentMethod.external_id,
        type: clientPaymentMethod.type,
        card_brand: clientPaymentMethod.card_brand,
        card_country: clientPaymentMethod.card_country,
        card_expiration_month: clientPaymentMethod.card_expiration_month,
        card_expiration_year: clientPaymentMethod.card_expiration_year,
        card_funding_type: clientPaymentMethod.card_funding_type,
        card_last_four: clientPaymentMethod.card_last_four,
    }));

    return clientPaymentAccountCopy;
});

// Client subscriptions
$subscriptions.on(fetchSubscriptions.doneData, (_, data) => data);

// Client invoices
$invoices.on(fetchInvoices.doneData, (_, data) => data);

// Fetch tax IDs
$taxIds.on(fetchTaxIds.doneData, (_, data) => data);

// Subscription Flex Month statuses (merged per subscription, so cards never overwrite each other)
$flexMonthStatuses.on(fetchFlexMonthStatus.done, (statuses, { params: subscriptionId, result }) => ({
    ...statuses,
    [subscriptionId]: result,
}));
